import {
  ActionEvents,
  PmfDisappointment,
  PmfQuestionType,
  PmfStepId,
  PmfSurveyConfig,
} from '@griply/types';

export const PMF_SURVEY_CONFIG: PmfSurveyConfig = {
  firstStepId: PmfStepId.HowWouldYouFeel,
  steps: {
    [PmfStepId.HowWouldYouFeel]: {
      id: PmfStepId.HowWouldYouFeel,
      type: PmfQuestionType.SingleSelect,
      titleKey: 'pmf-survey.how-would-you-feel.title',
      event: ActionEvents.PmfSurveyHowWouldYouFeel,
      options: [
        {
          value: PmfDisappointment.VeryDisappointed,
          labelKey: 'pmf-survey.how-would-you-feel.options.very-disappointed',
        },
        {
          value: PmfDisappointment.SlightlyDisappointed,
          labelKey:
            'pmf-survey.how-would-you-feel.options.slightly-disappointed',
        },
        {
          value: PmfDisappointment.NotDisappointed,
          labelKey: 'pmf-survey.how-would-you-feel.options.not-disappointed',
        },
        {
          value: PmfDisappointment.NoLongerUse,
          labelKey: 'pmf-survey.how-would-you-feel.options.no-longer-use',
        },
      ],
      branch: {
        [PmfDisappointment.VeryDisappointed]: PmfStepId.MainBenefit,
        [PmfDisappointment.SlightlyDisappointed]: PmfStepId.Improvement,
        [PmfDisappointment.NotDisappointed]: PmfStepId.Missing,
        [PmfDisappointment.NoLongerUse]: PmfStepId.ChurnReason,
      },
    },
    [PmfStepId.MainBenefit]: {
      id: PmfStepId.MainBenefit,
      type: PmfQuestionType.FreeText,
      titleKey: 'pmf-survey.main-benefit.title',
      placeholderKey: 'pmf-survey.main-benefit.placeholder',
      event: ActionEvents.PmfSurveyMainBenefit,
      next: PmfStepId.IdealPerson,
    },
    [PmfStepId.IdealPerson]: {
      id: PmfStepId.IdealPerson,
      type: PmfQuestionType.FreeText,
      titleKey: 'pmf-survey.ideal-person.title',
      placeholderKey: 'pmf-survey.ideal-person.placeholder',
      event: ActionEvents.PmfSurveyIdealPerson,
      next: null,
    },
    [PmfStepId.Improvement]: {
      id: PmfStepId.Improvement,
      type: PmfQuestionType.FreeText,
      titleKey: 'pmf-survey.improvement.title',
      placeholderKey: 'pmf-survey.improvement.placeholder',
      event: ActionEvents.PmfSurveyImprovement,
      next: null,
    },
    [PmfStepId.Missing]: {
      id: PmfStepId.Missing,
      type: PmfQuestionType.FreeText,
      titleKey: 'pmf-survey.missing.title',
      placeholderKey: 'pmf-survey.missing.placeholder',
      event: ActionEvents.PmfSurveyMissing,
      next: null,
    },
    [PmfStepId.ChurnReason]: {
      id: PmfStepId.ChurnReason,
      type: PmfQuestionType.FreeText,
      titleKey: 'pmf-survey.churn-reason.title',
      placeholderKey: 'pmf-survey.churn-reason.placeholder',
      event: ActionEvents.PmfSurveyChurnReason,
      next: null,
    },
  },
};
